import { ContainerStatusEnum } from "@gtpl/shared-models/common-models";
import { Column, CreateDateColumn, Entity, Index, JoinColumn, ManyToOne, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { LogBookItems } from "../log-book-items/log-book-items.entity";
@Entity('container_log_book')
export class ContainerLogBook {

    @PrimaryGeneratedColumn("increment", { name: 'container_log_book_id' })
    containerLogBookId: number;

    @Column("int", {
        nullable: true,
        name: "sale_order_id"
        })
    @Index({unique:true})
    saleOrderId: number;
    @Column("varchar", {
        nullable: true,
        length: 50,
        name: "container_no"
      })
      containerNo: string;

      @Column("varchar", {
        nullable: true,
        length: 50,
        name: "vehicle_no"
      })
      vehicleNo: string;

      @Column("varchar", {
        nullable: true,
        length: 50,
        name: "loading_start_time"
      })
      loadingStartTime: string;
      @Column("varchar", {
        nullable: true,
        length: 50,
        name: "loading_end_time"
      })
      loadingEndTime: string;
      @Column("datetime", {
        nullable: true,
        name: "loading_date"
      })
      loadingDate: Date;

      @Column("int",{
        nullable:false,
        name:"unit_id",
        })
    unitId:number;
    @Column("varchar", {
        nullable: true,
        name: "file_name",
    })
    fileName: string;
    @Column("varchar", {
        nullable: true,
        name: "file_path",
    })
    filePath: string;
    @Column("boolean",{
        nullable:false,
        default:true,
        name:"is_active"
        })
        isActive:boolean;
        
    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;


    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    @OneToMany(type => LogBookItems, containerlogBook => containerlogBook.containerlogBookInfo, { cascade: true })
    logBookInfo: LogBookItems[];
}